import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/focus-modal-close-icon.svg'
import _imports_1 from '@/assets/focus-mode-download.svg'
import _imports_2 from '@/assets/focus-mode-trash.svg'
import _imports_3 from '@/assets/toggle-icon.svg'


const _hoisted_1 = { class: "fixed top-0 right-0 bottom-0 left-0 z-[555] w-screen h-screen p-5 bg-white rounded-primary-radius" }
const _hoisted_2 = { class: "h-[40px] mb-3 w-full flex items-center justify-between" }
const _hoisted_3 = { class: "text-lg text-primary-text-color font-semibold leading-5 tracking-[0.01rem]" }
const _hoisted_4 = { class: "w-full flex items-center justify-between py-[6px] border-b boder-b-[#898790]" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "text-primary-text-color text-sm font-medium tracking-[0.01rem]" }
const _hoisted_7 = { class: "text-[#898790] text-sm tracking-[0.01rem] font-medium" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "w-full mt-2 flex gap-2" }
const _hoisted_11 = { class: "h-[calc(100vh-135px)] flex flex-col" }

import {
  ref,
  computed,
  onMounted,
  onUnmounted,
} from "vue";
import FocusModeModalImages from "./FocusModeModalImages.vue";
import FocusModeModalMain from "./FocusModeModalMain.vue";
import FocusModeModalSteps from "./FocusModeModalSteps.vue";
import { FocusImage, InstallationInput } from "@/types";
import FocusModeDeleteModal from "./FocusModeDeleteModal.vue";
import { useTranslate } from "@/composables/useTranslate";
import client from "@/utils/axios";
import { useRoute } from "vue-router";

// Route
type Props = {
  image: FocusImage | null;
  currentInput: any;
  currentStep: any;
  steps: any;
};

type Emits = {
  (event: "onClose"): void;
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FocusModeModal',
  props: {
    image: {},
    currentInput: {},
    currentStep: {},
    steps: {}
  },
  emits: ["onClose", "refresh"],
  setup(__props: any, { emit: __emit }) {

const route = useRoute();
const projectId = route.params.id;
const phaseId = route.params.phaseId;

const props = __props;
const emits = __emit;

const flattenedSteps = computed(() => {
  let tempSteps = props.steps.map((step: any) => {
    return {
      ...step,
      inputs: step.inputs.map((input: any) => {
        if (input.type === "repeatable_input" && input.subtype === "image") {
          let images = input.value.flatMap((item: any) => {
            return item.value.map((image: any) => {
              return {
                ...image,
                repeatableIndex: item.index,
              };
            });
          });
          return {
            ...input,
            value: [...images],
          };
        }
        if (input.type === "image" && input.parentId) {
          input.value = input.value.map((image: any) => {
            return {
              ...image,
              repeatableGroupIndex: input.repeatableGroupIndex,
            };
          });
        }
        return {
          ...input,
        };
      }),
    };
  });

  return tempSteps;
});

const { t } = useTranslate();

const selectedImage = ref<FocusImage | null>(props.image);
const selectedInput = ref<InstallationInput | null>(props.currentInput);

const selectedInputName = computed(() => {
  if (selectedInput.value?.parentId) {
    const allInputs = flattenedSteps.value.flatMap((step: any) => step.inputs);

    let parentInput = allInputs.find(
      (input: any) => input.id === selectedInput.value?.parentId
    );

    if (!parentInput) {
      return "";
    }

    if (parentInput.type === "repeatable_group") {
      let repeatableGroupDetails = parentInput.repeatableGroupDetails.find(
        (detail: any) =>
          selectedInput.value?.repeatableGroupIndex !== null &&
          selectedInput.value?.repeatableGroupIndex !== undefined
            ? detail.order === selectedInput.value?.repeatableGroupIndex + 1
            : false
      );

      return repeatableGroupDetails?.name + " / " + selectedInput.value?.name;
    }

    return parentInput.name + " / " + selectedInput.value.name;
  }
  return selectedInput.value?.name;
});

const currentInputImagesLength = computed(() => {
  let tempStep = flattenedSteps.value.find(
    (step: any) => step.id === selectedImage.value?.stepId
  );
  let tempInput = tempStep.inputs
    .filter((input: any) => input.type === "image" || input.subtype === "image")
    .find(
      (input: any) =>
        input.id === selectedImage.value?.inputId &&
        (selectedInput.value?.repeatableGroupIndex !== null &&
        selectedInput.value?.repeatableGroupIndex !== undefined
          ? input.repeatableGroupIndex ===
            selectedInput.value?.repeatableGroupIndex
          : true)
    );

  return tempInput.value ? tempInput.value.length : 0;
});

const currentImageIndex = computed(() => {
  let tempStep = flattenedSteps.value.find(
    (step: any) => step.id === selectedImage.value?.stepId
  );
  let tempInput = tempStep.inputs.find(
    (input: any) =>
      input.id === selectedImage.value?.inputId &&
      (selectedInput.value?.repeatableGroupIndex !== null &&
      selectedInput.value?.repeatableGroupIndex !== undefined
        ? input.repeatableGroupIndex ===
          selectedInput.value?.repeatableGroupIndex
        : true)
  );
  let images = [...tempInput.value];

  let index = images.findIndex(
    (image: FocusImage) => image.logId === selectedImage.value?.logId
  );
  return index + 1;
});

const isStepsMenuOpen = ref(true);
const isFocusModeDeleteModalOpen = ref(false);
const isFocusModeNoteModalOpen = ref(false);
const isLoading = ref(false);

const openFocusModeNoteModalHandler = () => {
  isFocusModeNoteModalOpen.value = !isFocusModeNoteModalOpen.value;
};

const toggleStepsMenu = () => {
  isStepsMenuOpen.value = !isStepsMenuOpen.value;
};

const openDeleteModalHandle = () => {
  isFocusModeDeleteModalOpen.value = true;
};

// Delete installation image
const onDeleteInstallationImage = async () => {
  isLoading.value = true;
  try {
    const postData = {
      logId: selectedImage.value?.logId,
    };

    await client.delete(
      `/projects/${projectId}/phase/${phaseId}/delete-picture`,
      { data: postData }
    );

    emits("refresh");
    isFocusModeDeleteModalOpen.value = false;
    nextImage();
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

// Add installation image comment
const onAddInstallationImageComment = async (
  comment: string,
  logId: number
) => {
  try {
    const postData = {
      logId: logId,
      comment: comment,
    };

    await client.post(
      `/projects/${projectId}/phase/${phaseId}/add-picture-comment`,
      postData
    );

    selectedImage.value = {
      ...selectedImage.value,
      comment: comment,
    };

    const step = props.steps.find(
      (s: any) => s.id === selectedImage.value?.stepId
    );
    const input = step?.inputs.find(
      (i: any) => i.id === selectedImage.value?.inputId
    );
    const img = input?.value.find(
      (i: FocusImage) => i.logId === selectedImage.value?.logId
    );

    if (img) {
      img.comment = comment;
    }

    emits("refresh");
    isFocusModeNoteModalOpen.value = false;
  } catch (error) {
    console.log(error);
  }
};

// Delete installation image comment
const onDeleteInstallationImageComment = async () => {
  try {
    const postData = {
      logId: selectedImage.value?.logId,
    };

    await client.delete(
      `/projects/${projectId}/phase/${phaseId}/delete-picture-comment`,
      { data: postData }
    );

    // Resetuj komentar u selectedImage
    selectedImage.value = {
      ...selectedImage.value,
      comment: "",
    };

    const step = props.steps.find(
      (s: any) => s.id === selectedImage.value?.stepId
    );
    const input = step?.inputs.find(
      (i: any) => i.id === selectedImage.value?.inputId
    );
    const img = input?.value.find(
      (i: FocusImage) => i.logId === selectedImage.value?.logId
    );
    if (img) {
      img.comment = "";
    }

    emits("refresh");
    isFocusModeNoteModalOpen.value = false;
  } catch (error) {
    console.log(error);
  }
};

const setSelectedImage = (image: FocusImage) => {
  selectedImage.value = image;
  let newSelectedStep = flattenedSteps.value.find((step: any) =>
    step.inputs.find((input: any) => input.id === image.inputId)
  );

  let newSelectedInput = newSelectedStep?.inputs.find(
    (input: any) =>
      input.id === image.inputId &&
      (image.repeatableGroupIndex !== null &&
      image.repeatableGroupIndex !== undefined
        ? input.repeatableGroupIndex === image.repeatableGroupIndex
        : true)
  );
  selectedInput.value = newSelectedInput;
};

const setSelectedInput = (inputId: number, repeatableGroupIndex?: number) => {
  let newSelectedStep = flattenedSteps.value.find((step: any) =>
    step.inputs.find((input: any) => input.id === inputId)
  );

  let newSelectedInput = newSelectedStep?.inputs.find(
    (input: any) =>
      input.id === inputId &&
      (repeatableGroupIndex !== null && repeatableGroupIndex !== undefined
        ? input.repeatableGroupIndex === repeatableGroupIndex
        : true)
  );

  let firstImageOnNewSelectedInput = newSelectedInput?.value
    ? newSelectedInput.value[0]
    : null;

  if (firstImageOnNewSelectedInput) {
    let tempImage: FocusImage = {
      logId: firstImageOnNewSelectedInput.logId,
      imageUrl: firstImageOnNewSelectedInput.imageUrl,
      comment: firstImageOnNewSelectedInput.comment,
      inputId: inputId,
      stepId: newSelectedStep.id,
      repeatableGroupIndex: newSelectedInput?.repeatableGroupIndex,
      terminId: firstImageOnNewSelectedInput.terminId,
      workers: firstImageOnNewSelectedInput.workers,
      createdAt: firstImageOnNewSelectedInput.createdAt,
    };

    setSelectedImage(tempImage);
  }
};

const nextInput = () => {
  const allInputs = flattenedSteps.value
    .flatMap((step: any) => step.inputs)
    .filter(
      (input: any) => input.type === "image" || input.subtype === "image"
    );

  const currentInputIndex = allInputs.findIndex(
    (input: any) =>
      input.id === selectedInput.value?.id &&
      (selectedInput.value?.repeatableGroupIndex !== null &&
      selectedInput.value?.repeatableGroupIndex !== undefined
        ? input.repeatableGroupIndex ===
          selectedInput.value?.repeatableGroupIndex
        : true)
  );

  if (currentInputIndex === -1) {
    return;
  }

  for (let i = currentInputIndex + 1; i < allInputs.length; i++) {
    const nextInput = allInputs[i];
    if (nextInput.value && nextInput.value.length > 0) {
      setSelectedInput(nextInput.id, nextInput.repeatableGroupIndex);
      return;
    }
  }
};

const previousInput = () => {
  const allInputs = flattenedSteps.value
    .flatMap((step: any) => step.inputs)
    .filter(
      (input: any) => input.type === "image" || input.subtype === "image"
    );

  const currentIndex = allInputs.findIndex(
    (input: any) =>
      input.id === selectedInput.value?.id &&
      (selectedInput.value?.repeatableGroupIndex !== null &&
      selectedInput.value?.repeatableGroupIndex !== undefined
        ? input.repeatableGroupIndex ===
          selectedInput.value?.repeatableGroupIndex
        : true)
  );

  if (currentIndex === -1) {
    return;
  }

  for (let i = currentIndex - 1; i >= 0; i--) {
    const prevInput = allInputs[i];
    if (prevInput.value && prevInput.value.length > 0) {
      setSelectedInput(prevInput.id, prevInput.repeatableGroupIndex);
      return;
    }
  }
};

const nextImage = () => {
  const currentStepIndex = flattenedSteps.value.findIndex(
    (step: any) => step.id === selectedImage.value?.stepId
  );
  if (currentStepIndex === -1) return;

  const currentStep = flattenedSteps.value[currentStepIndex];
  const currentStepInputs = currentStep.inputs.filter(
    (input: any) => input.type === "image" || input.subtype === "image"
  );
  const currentInputIndex = currentStepInputs.findIndex(
    (input: any) =>
      input.id === selectedImage.value?.inputId &&
      (selectedImage.value?.repeatableGroupIndex !== null &&
      selectedImage.value?.repeatableGroupIndex !== undefined
        ? input.repeatableGroupIndex ===
          selectedImage.value?.repeatableGroupIndex
        : true)
  );

  if (currentInputIndex === -1) return;
  const currentInput = currentStepInputs[currentInputIndex];

  if (!Array.isArray(currentInput.value)) {
    return;
  }

  const currentImageIndex = currentInput.value.findIndex(
    (image: FocusImage) => image.logId === selectedImage.value?.logId
  );

  // 1. Check for a next image in the SAME input
  if (currentImageIndex + 1 < currentInput.value.length) {
    const nextImg = currentInput.value[currentImageIndex + 1];
    setSelectedImage({
      logId: nextImg.logId,
      imageUrl: nextImg.imageUrl,
      comment: nextImg.comment,
      inputId: currentInput.id,
      stepId: currentStep.id,
      repeatableGroupIndex: nextImg.repeatableGroupIndex,
      terminId: nextImg.terminId,
      workers: nextImg.workers,
      createdAt: nextImg.createdAt,
    });
    return;
  }

  // 2. Check for a next input in the SAME step
  for (let i = currentInputIndex + 1; i < currentStepInputs.length; i++) {
    const nextInput = currentStepInputs[i];
    if (
      nextInput &&
      Array.isArray(nextInput.value) &&
      nextInput.value.length > 0
    ) {
      const firstImg = nextInput.value[0];
      setSelectedImage({
        logId: firstImg.logId,
        imageUrl: firstImg.imageUrl,
        comment: firstImg.comment,
        inputId: nextInput.id,
        stepId: currentStep.id,
        repeatableGroupIndex: nextInput.repeatableGroupIndex,
        terminId: firstImg.terminId,
        workers: firstImg.workers,
        createdAt: firstImg.createdAt,
      });
      selectedInput.value = nextInput;
      return;
    }
  }

  // 3. Check for a next step
  for (let s = currentStepIndex + 1; s < flattenedSteps.value.length; s++) {
    const nextStep = flattenedSteps.value[s];
    if (!nextStep) {
      return;
    }
    const nextStepInputs = nextStep.inputs.filter(
      (input: any) => input.type === "image" || input.subtype === "image"
    );
    for (let i = 0; i < nextStepInputs.length; i++) {
      const nextInput = nextStepInputs[i];
      if (
        nextInput &&
        Array.isArray(nextInput.value) &&
        nextInput.value.length > 0
      ) {
        const firstImg = nextInput.value[0];
        setSelectedImage({
          logId: firstImg.logId,
          imageUrl: firstImg.imageUrl,
          comment: firstImg.comment,
          inputId: nextInput.id,
          stepId: nextStep.id,
          repeatableGroupIndex: nextInput.repeatableGroupIndex,
          terminId: firstImg.terminId,
          workers: firstImg.workers,
          createdAt: firstImg.createdAt,
        });
        selectedInput.value = nextInput;
        return;
      }
    }
  }

  // 4. WRAP-AROUND: If no next image was found, go back to the very first image.
  for (let s = 0; s < flattenedSteps.value.length; s++) {
    const firstStep = flattenedSteps.value[s];
    const firstStepInputs = firstStep.inputs.filter(
      (input: any) => input.type === "image" || input.subtype === "image"
    );
    for (let i = 0; i < firstStepInputs.length; i++) {
      const firstInput = firstStepInputs[i];
      if (
        firstInput &&
        Array.isArray(firstInput.value) &&
        firstInput.value.length > 0
      ) {
        const firstImg = firstInput.value[0];
        setSelectedImage({
          logId: firstImg.logId,
          imageUrl: firstImg.imageUrl,
          comment: firstImg.comment,
          inputId: firstInput.id,
          stepId: firstStep.id,
          repeatableGroupIndex: firstInput.repeatableGroupIndex,
          terminId: firstImg.terminId,
          workers: firstImg.workers,
          createdAt: firstImg.createdAt,
        });
        selectedInput.value = firstInput;
        return; // Exit after finding the first image
      }
    }
  }
};

const previousImage = () => {
  const currentStepIndex = flattenedSteps.value.findIndex(
    (step: any) => step.id === selectedImage.value?.stepId
  );
  if (currentStepIndex === -1) return;

  const currentStep = flattenedSteps.value[currentStepIndex];
  const currentStepInputs = currentStep.inputs.filter(
    (input: any) => input.type === "image" || input.subtype === "image"
  );

  const currentInputIndex = currentStepInputs.findIndex(
    (input: any) =>
      input.id === selectedImage.value?.inputId &&
      (selectedImage.value?.repeatableGroupIndex !== null &&
      selectedImage.value?.repeatableGroupIndex !== undefined
        ? input.repeatableGroupIndex ===
          selectedImage.value?.repeatableGroupIndex
        : true)
  );
  if (currentInputIndex === -1) return;

  const currentInput = currentStepInputs[currentInputIndex];

  if (!currentInput.value || !Array.isArray(currentInput.value)) {
    return;
  }

  const currentImageIndex = currentInput.value.findIndex(
    (image: FocusImage) => image.logId === selectedImage.value?.logId
  );

  if (currentImageIndex > 0) {
    const prevImg = currentInput.value[currentImageIndex - 1];
    setSelectedImage({
      logId: prevImg.logId,
      imageUrl: prevImg.imageUrl,
      comment: prevImg.comment,
      inputId: currentInput.id,
      stepId: currentStep.id,
      repeatableGroupIndex: currentInput.repeatableGroupIndex,
      terminId: prevImg.terminId,
      workers: prevImg.workers,
      createdAt: prevImg.createdAt,
    });
    return;
  }

  for (let i = currentInputIndex - 1; i >= 0; i--) {
    const prevInput = currentStepInputs[i];
    if (
      prevInput.value &&
      Array.isArray(prevInput.value) &&
      prevInput.value.length > 0
    ) {
      const lastImg = prevInput.value[prevInput.value.length - 1];
      setSelectedImage({
        logId: lastImg.logId,
        imageUrl: lastImg.imageUrl,
        comment: lastImg.comment,
        inputId: prevInput.id,
        stepId: currentStep.id,
        repeatableGroupIndex: prevInput.repeatableGroupIndex,
        terminId: lastImg.terminId,
        workers: lastImg.workers,
        createdAt: lastImg.createdAt,
      });
      selectedInput.value = prevInput;
      return;
    }
  }

  for (let s = currentStepIndex - 1; s >= 0; s--) {
    const prevStep = flattenedSteps.value[s];
    if (!prevStep) {
      return;
    }
    const prevStepInputs = prevStep.inputs.filter(
      (input: any) => input.type === "image" || input.subtype === "image"
    );
    for (let i = prevStepInputs.length - 1; i >= 0; i--) {
      const prevInput = prevStepInputs[i];
      if (
        prevInput.value &&
        Array.isArray(prevInput.value) &&
        prevInput.value.length > 0
      ) {
        const lastImg = prevInput.value[prevInput.value.length - 1];
        setSelectedImage({
          logId: lastImg.logId,
          imageUrl: lastImg.imageUrl,
          comment: lastImg.comment,
          inputId: prevInput.id,
          stepId: prevStep.id,
          repeatableGroupIndex: prevInput.repeatableGroupIndex,
          terminId: lastImg.terminId,
          workers: lastImg.workers,
          createdAt: lastImg.createdAt,
        });
        selectedInput.value = prevInput;
        return;
      }
    }
  }
};

const handleKeyDown = (event: KeyboardEvent) => {
  switch (event.key) {
    case "ArrowUp":
      previousInput();
      break;
    case "ArrowDown":
      nextInput();
      break;
    case "ArrowRight":
      nextImage();
      break;
    case "ArrowLeft":
      previousImage();
      break;
    case "Escape":
      emits("onClose");
      break;
  }
};

onMounted(() => {
  document.addEventListener("keydown", handleKeyDown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeyDown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)("focus_mode_modal.focus_mode")), 1),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClose')))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          class: "w-[18px] h-[18px]",
          src: _imports_0,
          alt: "Close"
        }, null, -1)
      ]))])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex", isStepsMenuOpen.value ? 'gap-[24px]' : 'gap-0'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["transition-all duration-500 ease-in-out", {
          'w-[calc(100vw-239px)]': isStepsMenuOpen.value,
          'w-full': !isStepsMenuOpen.value,
        }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(selectedInputName.value), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(currentImageIndex.value) + "/" + _toDisplayString(currentInputImagesLength.value), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              href: `${selectedImage.value?.imageUrl}?download`,
              target: "_blank",
              class: "flex items-center justify-center"
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "Download"
              }, null, -1)
            ]))], 8, _hoisted_9),
            _createElementVNode("button", {
              onClick: openDeleteModalHandle,
              class: "flex items-center justify-center"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Delete"
              }, null, -1)
            ]))]),
            _createVNode(FocusModeDeleteModal, {
              "is-modal-open": isFocusModeDeleteModalOpen.value,
              "is-loading": isLoading.value,
              text: _unref(t)('focus_mode_modal.focus_delete_modal_message'),
              "is-delete-note": false,
              onOnClose: _cache[1] || (_cache[1] = ($event: any) => (isFocusModeDeleteModalOpen.value = false)),
              onOnImageDelete: onDeleteInstallationImage
            }, null, 8, ["is-modal-open", "is-loading", "text"]),
            (!isStepsMenuOpen.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: toggleStepsMenu,
                  class: "flex items-center justify-center"
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    class: "w-[16px] h-[16px]",
                    src: _imports_3,
                    alt: "Delete"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(FocusModeModalImages, {
              steps: flattenedSteps.value,
              "selected-image": selectedImage.value,
              onSetSelectedImage: setSelectedImage
            }, null, 8, ["steps", "selected-image"])
          ]),
          (selectedImage.value)
            ? (_openBlock(), _createBlock(FocusModeModalMain, {
                key: 0,
                image: selectedImage.value,
                "is-focus-mode-note-modal-open": isFocusModeNoteModalOpen.value,
                onOnAddImageComment: onAddInstallationImageComment,
                onOnNoteModalToggle: openFocusModeNoteModalHandler,
                onOnDeleteImageComment: onDeleteInstallationImageComment,
                onOnNextImage: nextImage,
                onOnPreviousImage: previousImage
              }, null, 8, ["image", "is-focus-mode-note-modal-open"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createVNode(FocusModeModalSteps, {
        "is-steps-menu-open": isStepsMenuOpen.value,
        steps: flattenedSteps.value,
        "selected-input": selectedInput.value,
        "repeatable-group-index": selectedInput.value?.repeatableGroupIndex,
        onOnToggle: toggleStepsMenu,
        onSetSelectedInput: setSelectedInput
      }, null, 8, ["is-steps-menu-open", "steps", "selected-input", "repeatable-group-index"])
    ], 2)
  ]))
}
}

})